import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { Form, SonForm, SubmitButton, TextAreaParam, TextParam, useForm } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';
import { TeaserInformationFormTemplate } from '../../PageManagement';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { Namespace } from '../../../translation/namespace';
import { formParamsUtils } from '../../../_lib/Form2/utils/formParamsUtils';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type TeaserInformationDefaultProps = {
  form: SonForm<
    | TextAreaParam<'teaserText'>
    | NestedParam<
        'imageuploadparams',
        'imageupload',
        TextParam<'alt'> | TextParam<'copyright'> | ImageFileParam<'image'>
      >
  >;
};

function TeaserInformationDefault({ form }: TeaserInformationDefaultProps) {
  const { t } = useSonTranslation('TeaserInformation');
  const { fetchUrl } = useBlockContext();
  const { delayedRefresh } = useRefreshBlock();

  const { formProps, fetchState, params } = useForm({ form, onSuccess: delayedRefresh });

  const imageUploadParams = params.getByName('imageuploadparams');
  const teaserText = params.getByName('teaserText');
  const image = formParamsUtils(imageUploadParams).getByName('image');

  return (
    <Form id="teaser-information-form" {...formProps}>
      <TeaserInformationFormTemplate
        fetchUrl={fetchUrl}
        imageUploadParams={imageUploadParams}
        teaserTextParam={teaserText}
      />
      <SubmitButton
        buttonLabel={t('saveButton')}
        messageSuccess={t('uploadSuccess')}
        messageSending={
          <>
            {t('uploadInProgress')}
            <Strong> {t(`${Namespace.phrases}:pleaseWait`)}</Strong>
          </>
        }
        // check how invalidFile and invalidOrientation messages are set
        messageFail={t('uploadFail.general', {
          maxWidth: image.constraints?.maxWidth,
          maxHeight: image.constraints?.maxHeight,
        })}
        fetchState={fetchState}
        customErrorTypeMessages={{
          invalidFile: t('phrases:mimeTypesError'),
          invalidColorSpace: t('phrases:mimeTypesError'),
        }}
      />
    </Form>
  );
}

export const TeaserInformationDefaultView = asView(TeaserInformationDefault);
export type TeaserInformationDefaultView = ComponentProps<typeof TeaserInformationDefaultView>;
